<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="6" md="6" xl="6">
                  <BaseSelect
                    :options="sourceTypeSelect.options"
                    :data="sourceTypeSelect.data"
                    ref="sourceTypeSelect"
                  >
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6">
                  <BaseSelect
                    :options="audioFileSelect.options"
                    :data="audioFileSelect.data"
                    ref="audioFileSelect"
                  >
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6">
                  <div class="form-group">
                    <label style="display: inline-flex;">Đài truyền thanh
                      <span class="required">*</span>
                      <CInputCheckbox custom :checked="isSelectedAllStation" class="ml-2"
                                      @update:checked="changeSelectedAllStation($event)"
                                      addInputClasses="override-custom"></CInputCheckbox>
                      Chọn tất cả
                    </label>

                    <multiselect
                      id="stationSelect"
                      v-model="audioStationSelect.data.model"
                      placeholder="Chọn đài truyền thanh"
                      label="text"
                      track-by="value"
                      :options="audioStationSelect.options"
                      selectLabel="Chọn"
                      deselectLabel="Bỏ chọn"
                      selectedLabel="Đã chọn"
                      :close-on-select="false"
                      :class="!(audioStationSelect.data.validator && audioStationSelect.data.validator.isValid == true) ? 'input-error' : ''"
                      :multiple="true">
                      <span slot="noResult">Không có dữ liệu tương ứng!</span>
                      <span slot="noOptions">Danh sách rỗng!</span>
                    </multiselect>

                    <div class="valid-error"
                         v-show="!(audioStationSelect.data.validator ? audioStationSelect.data.validator.isValid : true)">
                      {{
                        audioStationSelect.data.validator
                          ? audioStationSelect.data.validator.errorMessage
                          : ""
                      }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6">
                  <BaseSelect
                    :options="modeSelect.options"
                    :data="modeSelect.data"
                    ref="modeSelect"
                  >
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model != 2">
                  <div class="form-group">
                    <label for="dateRanger">Ngày bắt đầu - Ngày kết thúc
                      <span class="required">*</span></label>
                    <DatePicker locale="vi"
                      id="dateRanger"
                      v-model="dateRange"
                      is-range
                      class="datepicker"
                      :input-props="{ readonly: true }"
                      :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }"
                      :min-date="new Date()"
                    >
                      <template v-slot="{ inputValue, inputEvents }">
                        <input
                          :value="inputValue.start + ' - ' + inputValue.end"
                          v-on="inputEvents.start"
                          class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300 " readonly
                        />
                      </template>
                    </DatePicker>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model == 1">
                  <BaseSelect
                    :options="modeSchedule.options"
                    :data="modeSchedule.data"
                    ref="modeSchedule">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model == 1 || modeSelect.data.model == 0">
                  <div class="form-group mb-0"
                       :class="!(validatorRangeTimes ? validatorRangeTimes.isValid : true) ? 'input-error' : ''">
                    <label>Thời điểm phát <span class="required">*</span></label>
                    <CCard class="mb-1">
                      <CCardBody style="padding-top: 5px !important">
                        <CRow>
                          <CCol sx="12" sm="12" md="6" lg="6" xl="3" v-for="(each, index) in timeRange"
                                :key="index">
                            <DatePicker locale="vi"
                              mode="time"
                              :masks="{ input: 'HH:MM', data: 'HH:MM' }"
                              :value="each"
                              is-range
                              is24hr
                              @input="changeTimeRange($event, index)"
                              ref="timeRange">
                              <template v-slot="{ inputValue, inputEvents , togglePopover, hidePopover}">
<!--                                <CInput class="btn-time-ranger"-->
<!--                                        :value="inputValue.start + ' - ' + inputValue.end"-->
<!--                                        v-on="inputEvents.start"-->
<!--                                        readonly-->
<!--                                />-->
                                <div class="form-group">
                                  <input type="text"
                                         :style="each.isValid ? 'border-color:red!important;' : ''"
                                         class="btn-time-ranger form-control"
                                         :value="inputValue.start + ' - ' + inputValue.end" readonly
                                         v-on="inputEvents.start">
                                </div>
                                <svg
                                  v-c-tooltip.hover="'Xóa'"
                                  class="w-1 h-1 btn-remove-time"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  @click="removeTimeRange(index)"
                                >
                                  <path d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                              </template>
                            </DatePicker>
                          </CCol>
                        </CRow>
                        <CRow>
                          <CCol>
                            <CButton color="primary" class="mt-3" @click="addTimeRange()">
                              <i class="fa fa-plus"></i> Thêm
                            </CButton>
                            <CButton color="secondary" class="mt-3 ml-2" @click="sortRangeTime(true)">
                              <i class="fa fa-sort"></i> Sắp xếp
                            </CButton>
                            <CButton color="secondary" class="mt-3 ml-2" @click="timeRange = []">
                              <i class="fa fa-eraser"></i> Xóa tất cả
                            </CButton>
                          </CCol>
                        </CRow>
                      </CCardBody>
                    </CCard>
                    <div class="valid-error" v-show="!(validatorRangeTimes ? validatorRangeTimes.isValid : true)">
                      {{ validatorRangeTimes ? validatorRangeTimes.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model == 2">
                  <div class="form-group" :class="!(validatorEndTimeUrgency ? validatorEndTimeUrgency.isValid : true) ? 'input-error' : ''">
                    <label for="datepicker">Thời gian kết thúc phát
                      <span class="required">*</span></label>
                    <br/>
                    <DatePicker locale="vi"
                      id="endTimeUrgencyPicker"
                      mode="time"
                      v-model="endTimeUrgency"
                      :masks="{ input: 'HH:MM', data: 'HH:MM' }"
                      is24hr>
                    </DatePicker>
                  </div>
                  <div class="form-row">
                    <div class="valid-error" style="padding: unset!important;"
                         v-show="!(validatorEndTimeUrgency ? validatorEndTimeUrgency.isValid : true)">
                      {{ validatorEndTimeUrgency ? validatorEndTimeUrgency.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSchedule.data.model == 0 && modeSelect.data.model == 1">
                  <div class="form-group">
                    <label for="selectedDateWeek">Ngày phát <span class="required">*</span></label>
                    <multiselect
                      id="selectedDateWeek"
                      v-model="selectedDateWeek.data.model"
                      placeholder="Ngày phát"
                      label="value"
                      track-by="key"
                      :options="selectedDateWeek.data.items"
                      selectLabel="Chọn"
                      deselectLabel="Bỏ chọn"
                      selectedLabel="Đã chọn"
                      :close-on-select="false"
                      :multiple="true"
                      :class="!(selectedDateWeek.data.validator ? selectedDateWeek.data.validator.isValid : true) ? 'input-error' : ''"
                    >
                      <span slot="noResult">Không có dữ liệu tương ứng!</span>
                      <span slot="noOptions">Danh sách rỗng!</span>
                    </multiselect>
                    <div class="valid-error"
                         v-show="!(selectedDateWeek.data.validator ? selectedDateWeek.data.validator.isValid : true)">
                      {{ selectedDateWeek.data.validator ? selectedDateWeek.data.validator.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model == 1 && modeSchedule.data.model == 1">
                  <div class="form-group"
                       :class="!(validatorDates ? validatorDates.isValid : true) ? 'input-error' : ''">
                    <label for="datepicker">Ngày phát <span class="required">*</span></label>
                    <CCard class="mb-1">
                      <CCardBody style="padding-top: 5px !important">
                        <DatePicker locale="vi"
                          id="datepicker"
                          mode="date"
                          v-model="selectedDate.date"
                          :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
                          :min-date="minDate"
                          :max-date="maxDate"
                          :is-required="true"
                        >
                          <template
                            #default="{
                              inputValue,
                              togglePopover,
                              hidePopover,
                            }"
                          >
                            <div class="flex flex-wrap">
                              <CButton
                                v-for="(each, i) in dates"
                                :key="each.date != null ? each.date.getTime() : new Date().getTime()"
                                color="light"
                                class="mr-3 mt-3 btn-date"
                                style="position: relative"
                                @click.stop=" dateSelected($event, each, togglePopover)"
                                ref="btnDate"
                              >
                                {{ $helper.formatDateDDMMYYYY(each.date) }}
                                <div class="btn-remove">
                                  <svg
                                    class="w-1 h-1"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    @click.stop="removeDate(each, hidePopover)"
                                  >
                                    <path d="M6 18L18 6M6 6l12 12"></path>
                                  </svg>
                                </div>
                              </CButton>
                            </div>
                          </template>
                        </DatePicker>
                        <CButton color="primary" class="mt-3" :disabled="checkDisableAddDate" @click="addDate">
                          <i class="fa fa-plus"></i> Thêm ngày
                        </CButton>
                        <CButton color="secondary" class="mt-3 ml-2" @click="dates = []">
                          <i class="fa fa-eraser"></i> Xóa tất cả
                        </CButton>
                      </CCardBody>
                    </CCard>
                    <div class="valid-error" v-show="!(validatorDates ? validatorDates.isValid : true)">
                      {{ validatorDates ? validatorDates.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
              </CRow>
              <br/>
              <CRow>
                <CCol xs="12" md="12" lg="12" xl="12">
                  <CButton color="primary" @click="submitData()"
                  ><i class="fa fa-send"></i> Gửi tệp tin
                  </CButton
                  >
                  <CButton color="secondary" class="ml-2" @click="resetData()"
                  ><i class="fa fa-eraser"></i> Làm mới
                  </CButton
                  >
                </CCol>
              </CRow>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseTable from "../../base/BaseDataTable";
import ModalConfirm from "../../base/BaseModalConfirm";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "../../base/BaseSelect2";
import {DatePicker} from "v-calendar";
import {LOCATION_CODE_NAME} from "@/constant";
import Multiselect from "vue-multiselect";
import BaseLoading from "../../base/BaseFormLoading";

export default {
  name: "SendFileToStation",
  components: {
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    Multiselect,
    BaseLoading,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    let today = new Date();
    return {
      isSelectedAllStation: false,
      loading: {value: false},
      minDate: today,
      maxDate: today,
      dates: [],
      selectedDate: {},
      endTimeUrgency: this.$helper.plusDate(10, 'm')._d,
      actionData: {
        model: {
          listFileSelectedId: [],
        },
      },
      dateRange: {
        start: new Date(),
        end: new Date(),
      },
      timeRange: [],
      sourceTypeSelect: {
        options: {
          filter: false,
          label: "Nguồn bản tin <span class='required'>*</span>",
        },
        data: {
          name: "sourceType",
          items: [
            {key: "-1", value: "Tất cả nguồn bản tin"},
            {key: "0", value: "Bản tin TW"},
            {key: "1", value: "Bản tin biên tập"},
            // {key: "2", value: "Chuyển đổi văn bản sang giọng đọc"},
          ],
          model:
            this.$route.query && (this.$route.query.sourceType || this.$route.query.sourceType == 0) ? this.$route.query.sourceType : "-1",
        },
      },
      audioFileSelect: {
        options: {
          filter: true,
          label: "Bản tin <span class='required'>*</span>",
          keyField: "value",
          valueField: "text",
          selectAllText: "Chọn bản tin",
        },
        data: {
          name: "audio-file",
          model: this.$route.query && this.$route.query.fileId ? this.$route.query.fileId : "",
          source: {
            url: "/audio-file/listAudioFileBySourceType",
            dataSubmit: function () {
              return {
                sourceType: that.sourceTypeSelect.data.model
              };
            },
            ignoreDefaultData: true,
            isJsonContentType: false,
            response: function (dataResponse) {
              if (that.$route.query && that.$route.query.fileId) {
                that.audioFileSelect.data.model = that.$route.query.fileId;
              }
              return dataResponse.data;
            },
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.audioFileSelect.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Bản tin không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      audioStationSelect: {
        options: [],
        data: {
          name: "audio-station",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.audioStationSelect.data.model;
              if (value === "" || that.audioStationSelect.data.model.length == 0) {
                this.isValid = false;
                this.errorMessage = "Đài truyền thanh không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      modeSelect: {
        options: {
          label: "Chế độ phát",
          filter: false,
        },
        data: {
          name: "mode",
          items: [
            {key: "0", value: "Khung giờ cố định"},
            {key: "1", value: "Theo lịch phát đã thiết lập"},
            {key: "2", value: "Khẩn cấp phát ngay"},
          ],
          model: "0",
        },
      },
      modeSchedule: {
        options: {
          label: "Kiểu lịch",
          filter: false,
        },
        data: {
          name: "modeSchedule",
          items: [
            {key: "0", value: "Theo ngày trong tuần"},
            {key: "1", value: "Theo ngày trong tháng"},
          ],
          model: "0",
        },
      },
      selectedDateWeek: {
        options: {
          label: "Ngày phát",
        },
        data: {
          name: "selectedDateWeek",
          model: "",
          items: [
            {key: "2", value: "Thứ 2"},
            {key: "3", value: "Thứ 3"},
            {key: "4", value: "Thứ 4"},
            {key: "5", value: "Thứ 5"},
            {key: "6", value: "Thứ 6"},
            {key: "7", value: "Thứ 7"},
            {key: "1", value: "Chủ nhật"},
          ],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.selectedDateWeek.data.model;
              if (
                (value === "" || value.length == 0) &&
                that.modeSelect.data.model == 1 &&
                that.modeSchedule.data.model == 0
              ) {
                this.isValid = false;
                this.errorMessage = "Ngày phát phát không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      validatorRangeTimes: {
        isValid: true,
        errorMessage: "",
        valid: function () {
          let value = that.timeRange;
          if ((value === "" || value.length == 0) && that.modeSelect.data.model != 2) {
            this.isValid = false;
            this.errorMessage = "Thời điểm phát không được để trống";
          } else {
            // this.isValid = true;
            var validRes = that.validateRangeTimeSorted();
            this.isValid = validRes.isValid;
            if (this.isValid) {
              this.errorMessage = "";
            } else {
              if (validRes.type == 0) {
                this.errorMessage = "Thời gian bắt đầu phải lớn hơn hoặc bằng thời gian hiện tại";
              } else {
                this.errorMessage = "Khoảng thời gian phát bị trùng nhau";
              }
              // that.scrollToValidate(that.$refs.rangeTimes.scrollHeight)
            }
          }
          return this.isValid;
        },
      },
      validatorDates: {
        isValid: true,
        errorMessage: "",
        valid: function () {
          let value = that.dates;
          if (
            (value === "" || value.length == 0) &&
            that.modeSelect.data.model == 1 &&
            that.modeSchedule.data.model == 1
          ) {
            this.isValid = false;
            this.errorMessage = "Ngày phát phát không được để trống";
          } else {
            this.isValid = true;
          }
          return this.isValid;
        },
      },
      validatorEndTimeUrgency: {
        isValid: true,
        errorMessage: "",
        valid:
          function () {
            let value = that.endTimeUrgency.getTime();
            if (value !== "" && that.modeSelect.data.model == 2) {
              if (value <= new Date()) {
                this.isValid = false;
                this.errorMessage = "Thời gian kết thúc phát phải lớn hơn thời gian hiện tại";
              } else {
                this.isValid = true;
              }
            }
            return this.isValid;
          },
      },
    };
  },
  computed: {
    checkDisableAddDate() {
      let number = this.dateRange.end.getTime() - this.dateRange.start.getTime();
      const daysDiff = number / (1000 * 60 * 60 * 24);
      if (this.dates.length <= daysDiff) {
        return false;
      }
      return true;
    }
  },
  methods: {
    changeSelectedAllStation(value) {
      if (value) {
        this.audioStationSelect.data.model = this.audioStationSelect.options;
      } else {
        this.audioStationSelect.data.model = '';
      }
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= that.audioFileSelect.data.validator.valid();
      isValid &= that.audioStationSelect.data.validator.valid();
      isValid &= that.validatorRangeTimes.valid();
      isValid &= that.selectedDateWeek.data.validator.valid();
      isValid &= that.validatorDates.valid();
      isValid &= that.validatorEndTimeUrgency.valid();
      if (!isValid) {
        return;
      } else {
        let res = {};
        let dates = [];
        for (let i = 0; i < that.dates.length; i++) {
          dates.push(that.$helper.formatDateDDMMYYYY(that.dates[i].date.getTime()));
        }
        let startTimes = [];
        let endTimes = [];
        for (let i = 0; i < that.timeRange.length; i++) {
          startTimes.push(that.$helper.formatHHMMSS(that.timeRange[i].start.getTime()));
          endTimes.push(that.$helper.formatHHMMSS(that.timeRange[i].end.getTime()));
        }

        if (that.modeSelect.data.model == 2) {
          endTimes.push(that.$helper.formatHHMMSS(that.endTimeUrgency.getTime()));
        }

        res.dates = dates;
        res.startTimes = startTimes;
        res.endTimes = endTimes;
        res.fromDate = that.$helper.formatDateDDMMYYYY(that.minDate.getTime());
        res.toDate = that.$helper.formatDateDDMMYYYY(that.maxDate.getTime());
        res.sourceType = that.sourceTypeSelect.data.model;
        res.fileId = that.audioFileSelect.data.model;
        res.lstStation = [];

        for (let i = 0; i < that.audioStationSelect.data.model.length; i++) {
          res.lstStation.push({
            id: that.audioStationSelect.data.model[i].value,
            contractorInformationId: that.audioStationSelect.data.model[i].type,
          });
        }
        res.mode = that.modeSelect.data.model;
        res.modeSchedule = that.modeSchedule.data.model;
        if (that.selectedDateWeek.data.model.length > 0) {
          res.selectedDateWeek = [];
          for (let i = 0; i < that.selectedDateWeek.data.model.length; i++) {
            res.selectedDateWeek.push(that.selectedDateWeek.data.model[i].key);
          }
        }
        that.$helper.loadDataSource({
          loading: that.loading,
          url: "/send-to-station/send-audio",
          dataSubmit: function () {
            return res;
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({message: that.$helper.getStringError(response.data.data),});
              that.$helper.setupErrorModel(response.data.data, that.$data);
            } else {
              that.showSuccessMsg({message: "Hệ thống đã gửi bản tin. Vui lòng đợi thông báo. Xin cảm ơn!"});
              that.resetData();
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          },
        });
      }
    },
    changeTimeRange(event, index) {
      this.timeRange.splice(index, 1, event);
    },
    addTimeRange() {
      // this.timeRange.push({start: new Date(), end: new Date()})
      if (this.timeRange.length == 0) {
        this.timeRange.push(
          {
            start: this.$helper.plusDateTime(5, 'm').second(0).millisecond(0)._d,
            end: this.$helper.plusDateTime(13, 'm').second(0).millisecond(0)._d,
            isValid: false
          })
      } else {
        var rangeTimeSorted = this.sortRangeTime();
        var timeEnd = rangeTimeSorted[rangeTimeSorted.length - 1].end;
        this.timeRange.push({
          start: timeEnd,
          end: moment(timeEnd).add(10, 'm').second(0).millisecond(0).toDate(),
          isValid: false
        })
      }
    },
    sortRangeTime(isClick) {
      var timeArr = this.timeRange;
      var sortedTime = [];
      var tempTimesArr = [];
      timeArr.forEach(function (each, index) {
        tempTimesArr.push({time: moment(each.start, "hh:mm:ss").unix(), index: index});
      });
      tempTimesArr.sort(function (a, b) {
        return a.time - b.time;
      });

      tempTimesArr.forEach(function (t) {
        sortedTime.push(timeArr[t.index])
      });
      if (isClick) {
        this.timeRange = sortedTime;
      } else {
        return sortedTime;
      }
    },
    validateRangeTimeSorted() {
      var rangeTimeSorted = this.sortRangeTime();
      var response = {
        isValid: true,
      }
      var isValid = true;
      var now = moment().second(0).millisecond(0)._d.getTime();
      for (let i = 0; i < rangeTimeSorted.length; i++) {
        var _from = new Date(this.dateRange.start.setHours(rangeTimeSorted[i].start.getHours(), rangeTimeSorted[i].start.getMinutes(), 0));
        if (_from < now) {
          response.isValid = false;
          response.type = 0;
          break;
        }
        if (i > 0) {
          if (rangeTimeSorted[i].start.getTime() < rangeTimeSorted[i - 1].end.getTime()) {
            response.isValid = false;
            response.type = 1;
            break;
          }
        }
      }
      return response;
    },
    removeTimeRange(index) {
      this.timeRange.splice(index, 1);
    },
    loadDataAudioStation() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/audio-station/list-send-audio-station-id-name",
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.audioStationSelect.options = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    addDate() {
      // let that = this;
      // // this.dates.push({date: new Date()});
      // var date = new Date();
      // date.setDate(this.dateRange.start.getDate());
      // this.dates.push({date: date});
      // this.$nextTick(() => {
      //   setTimeout(() => {
      //     const btn = that.$refs.btnDate[that.$refs.btnDate.length - 1];
      //     btn.click();
      //   }, 50);
      // });
      let that = this;

      let number = this.dateRange.end.getTime() - this.dateRange.start.getTime();
      const daysDiff = number / (1000 * 60 * 60 * 24);
      if (daysDiff < this.dates.length) {
        return;
      }

      var date = new Date();
      date.setDate(this.dateRange.start.getDate());
      this.dates.push({date: date});
      this.$nextTick(() => {
        setTimeout(() => {
          const btn = that.$refs.btnDate[that.$refs.btnDate.length - 1];
          btn.click();
        }, 50);
      });
    },
    removeDate(date, hide) {
      this.dates = this.dates.filter((d) => d !== date);
      hide();
    },
    dateSelected(e, date, toggle) {
      this.selectedDate = date;
      toggle({ref: e.target});
    },
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    resetData() {
      this.sourceTypeSelect.data.model = "-1";
      this.audioFileSelect.data.model = "";
      this.audioStationSelect.data.model = "";
      this.modeSelect.data.model = "0";
      this.modeSchedule.data.model = "0";
      this.minDate = new Date();
      this.maxDate = new Date();
      this.endTimeUrgency = this.$helper.plusDate(10, 'm')._d
      this.timeRange = [];
      (this.dateRange = {
        start: this.minDate,
        end: this.maxDate,
      }),
        this.resetTime();
    },
    resetTime() {
      this.startTimes = [];
      this.endTimes = [];
      this.selectedDateWeek.data.model = [];
      this.dates = [];
      this.timeRange = [];
    },
  },
  created: function () {
  },
  mounted() {
    this.loadDataAudioStation();
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.minDate = newValue.start;
        this.maxDate = newValue.end;
      }
    },
    "sourceTypeSelect.data.model": function () {
      this.$refs.audioFileSelect.loadData();
    },
    "audioStationSelect.data.model": function (data) {
      if (data.length == this.audioStationSelect.options.length) {
        this.isSelectedAllStation = true;
      } else {
        this.isSelectedAllStation = false;
      }
    },
    "modeSelect.data.model": function (newValue) {
      if (newValue) {
        if(newValue == 2) {
          this.minDate = new Date();
          this.maxDate = new Date();
        }
        this.resetTime();
      }
    },
    "modeSchedule.data.model": function (newValue) {
      if (newValue) {
        this.resetTime();
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.btn-date:hover .btn-remove {
  display: inline-flex !important;
}

.btn-remove {
  display: none !important;
  position: absolute;
  width: 15px;
  height: 15px;
  background: red;
  color: white;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  top: -5px;
  right: -5px;
}

.custom-checkbox
.custom-control-input:indeterminate
~ .custom-control-label::before {
  border-color: unset;
  background-color: unset;
}

.form-group.input-error .card {
  border-color: #ff7070 !important;
}

.btn-time-ranger:hover ~ .btn-remove-time {
  display: inline-block !important;
}

.btn-remove-time {
  width: 18px;
  cursor: pointer;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 0;
  padding: 2px;
  border-radius: 50%;
  background: red;
  color: white;
}
</style>
<style>
.input-error #endTimeUrgencyPicker {
  border-color: #ff7070;
}

.override-custom {
  opacity: 1 !important;
  z-index: 10 !important;
}

.multiselect.input-error .multiselect__tags {
  border-color: #ff7070;
}

.vc-date {
  display: none !important;
}

.multiselect,
.multiselect .multiselect__tags {
  /*height: 36px !important;*/
  min-height: 36px !important;
}

.multiselect__input {
  line-height: unset !important;
  /*padding-left: 1px !important;*/
  font-size: 14px !important;
  padding-top: 5px !important;
}

.multiselect .multiselect__tags {
  padding-top: 0px !important;
}

.multiselect__placeholder {
  padding-top: 7px !important;
  margin: 0 !important;
}

.multiselect .multiselect__tag {
  margin-top: 5px !important;
  margin-bottom: 0 !important;
}
</style>
